export const ProvinceEnum = Object.freeze({
  Sindh: "Sindh",
  Punjab: "Punjab",
  Balochistan: "Balochistan",
  KPK: "KPK",
  Islamabad: "Islamabad",
  AzadKashmir: "Azad Kashmir",
  GilgitBaltistan: "Gilgit-Baltistan",
});

const PROVINCE_LABELS = Object.freeze({
  [ProvinceEnum.Sindh]: "Sindh",
  [ProvinceEnum.Punjab]: "Punjab",
  [ProvinceEnum.Balochistan]: "Balochistan",
  [ProvinceEnum.KPK]: "KPK",
  [ProvinceEnum.Islamabad]: "Islamabad",
  [ProvinceEnum.AzadKashmir]: "Azad Kashmir",
  [ProvinceEnum.GilgitBaltistan]: "Gilgit Baltistan",
});

const PROVINCE_ALIASES = Object.freeze({
  "azad kashmir": ProvinceEnum.AzadKashmir,
  ajk: ProvinceEnum.AzadKashmir,
  balochistan: ProvinceEnum.Balochistan,
  "gilgit baltistan": ProvinceEnum.GilgitBaltistan,
  "gilgit-baltistan": ProvinceEnum.GilgitBaltistan,
  gilgit: ProvinceEnum.GilgitBaltistan,
  baltistan: ProvinceEnum.GilgitBaltistan,
  islamabad: ProvinceEnum.Islamabad,
  "khyber pakhtunkhwa": ProvinceEnum.KPK,
  kpk: ProvinceEnum.KPK,
  pakhtunkhwa: ProvinceEnum.KPK,
  punjab: ProvinceEnum.Punjab,
  sindh: ProvinceEnum.Sindh,
});

export const provinceOptions = Object.freeze(
  Object.values(ProvinceEnum).map((value) => ({
    value,
    label: PROVINCE_LABELS[value],
  }))
);

export const normalizeProvinceValue = (province) => {
  const value = String(province || "").trim();
  if (!value) return "";

  const normalized = value.toLowerCase();
  return PROVINCE_ALIASES[normalized] || value;
};

export const formatProvinceLabel = (province) => {
  const value = normalizeProvinceValue(province);
  return PROVINCE_LABELS[value] || value;
};

export const getProvinceOption = (province) => {
  const value = normalizeProvinceValue(province);
  return provinceOptions.find((option) => option.value === value) || null;
};

export const detectPakistanProvince = (addressText = "", rawResult = null) => {
  const chunks = [];

  if (rawResult && Array.isArray(rawResult.address_components)) {
    rawResult.address_components.forEach((component) => {
      chunks.push(component.long_name, component.short_name);
    });
  }

  chunks.push(addressText);

  const normalizedAddress = chunks
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  if (normalizedAddress.includes("sindh")) return ProvinceEnum.Sindh;
  if (normalizedAddress.includes("punjab")) return ProvinceEnum.Punjab;
  if (normalizedAddress.includes("balochistan")) return ProvinceEnum.Balochistan;
  if (
    normalizedAddress.includes("khyber") ||
    normalizedAddress.includes("kpk") ||
    normalizedAddress.includes("pakhtunkhwa")
  ) {
    return ProvinceEnum.KPK;
  }
  if (normalizedAddress.includes("islamabad")) return ProvinceEnum.Islamabad;
  if (
    normalizedAddress.includes("kashmir") ||
    normalizedAddress.includes("muzaffarabad") ||
    normalizedAddress.includes("ajk") ||
    normalizedAddress.includes("mirpur")
  ) {
    return ProvinceEnum.AzadKashmir;
  }
  if (
    normalizedAddress.includes("gilgit") ||
    normalizedAddress.includes("baltistan")
  ) {
    return ProvinceEnum.GilgitBaltistan;
  }

  return "";
};
